import React from 'react';
import { IconButton, V2CloseIcon } from '@paypalcorp/pp-react';
import { closeWindow, isInContext } from '../utility/inContextDonation';
import TemplateData from '../utility/getTemplateData';
import { getDismissEventName } from '../utility/externalIntegrationUtils';
import { localsMessages } from '../utility/getTemplateData';
import PropTypes from 'prop-types';
import { trackLinkClick } from '../fpti/fpti';
import { LINK_NAME } from '../fpti/fptiConstants';

const messages = localsMessages('common/header');

export default function CloseButton(props) {
  const { button } = ({} = messages || {});

  const handleClose = () => {
    trackLinkClick(LINK_NAME.CANCEL, {
      eventName: getDismissEventName(),
    });
    if (isInContext()) {
      closeWindow();
      return;
    }
    window.location.href = TemplateData.charityCancelUrl;
  };

  return (
    <IconButton
      data-testid="close-button"
      svgIconComponent={V2CloseIcon}
      onClick={handleClose}
      className={'close-button'}
      buttonType="tertiary"
      {...props}
    >
      {button.close}
    </IconButton>
  );
}

CloseButton.propTypes = {
  isDarkButton: PropTypes.bool,
};
